import { DASHBOARD_MAINCONTENT_HEADER, SIP_CONNECTION_STATUS } from "../types";

const initialState = {
  maincontent_header: {
    active_tab: "",
  },
  sip_connection_status: {
    registered: false,
    snooping: false,
  },
};

const dashboardReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case DASHBOARD_MAINCONTENT_HEADER:
      return {
        ...state,
        maincontent_header: payload,
      };
    case SIP_CONNECTION_STATUS:
      return {
        ...state,
        sip_connection_status: {
          ...state.sip_connection_status,
          ...payload,
        },
      };
    default:
      return state;
  }
};

export default dashboardReducer;
